import { getLocalStorage, setLocalStorage } from "@/utils/storage";
let socket = null
let restart = true // 是否需要重连的标记
let timer = null // 重连定时器
let sendTimer = null // 心跳定时器
// 发送消息后的回调
// 发送消息后的回调类型，用以区分是哪个请求的回调方法
let callbackArr = []
let globalMesgCallback = null
let destory = false
const global: any = window
const url = global.EXTRANET_WEBSOCKET_URL ? global.EXTRANET_WEBSOCKET_URL : 'ws://127.0.0.1:10012/extranetService'

/** 函数说明
 * @param {function} mesgCallback 必填 指定当从服务器接受到信息时的回调函数
 * */
const initWebSocket = (mesgCallback) => {
  restart = true
  globalMesgCallback = mesgCallback
  if (typeof (WebSocket) === 'undefined') {
    alert('您的浏览器不支持Websocket')
  } else {
    // 实例化socket
    socket = new WebSocket(url)
    // 监听socket连接成功
    socket.onopen = () => {
      console.log('websocket连接成功')
      clearInterval(timer)
      timer = null
      if (!sendTimer) {
        sendTestMes()
      }
    }
    // 监听socket连接关闭
    socket.onclose = () => {
      console.log('websocket连接关闭')
      clearInterval(sendTimer)
      sendTimer = null
    }
    // 监听socket错误信息
    socket.onerror = (e) => {
      console.log('websocket连接错误：', e)
      clearInterval(sendTimer)
      sendTimer = null
      clearInterval(timer)
      sendTimer = null
      if (restart && !destory) {
        timer = setInterval(() => {
          initWebSocket(mesgCallback)
        }, 20000)
      }
    }
    // 监听socket消息
    socket.onmessage = (e) => {
      // console.log('回调:',callbackArr)
      let type = JSON.parse(e.data).header.type
      let index = callbackArr.findIndex(item => item.callbackType === type)
      if (callbackArr.length && index > -1) {
        // 需要特殊处理的回调方法
        callbackArr[index].onMsgCallback(JSON.parse(e.data))
        callbackArr.splice(index, 1)
      } else {
        // 普通接受的消息，不需要特别标记
        mesgCallback && mesgCallback(JSON.parse(e.data))
      }
    }
  }
}

// 向服务器发送数据
const sendMsg = (message, callback?) => {
  if (!socket) {
    return
  }
  const data = JSON.stringify(message)

  // websocket服务开启后，正式处理特殊回调
  if (callback && socket.readyState === socket.OPEN) {
    let onMsgCallback = callback.fn
    let callbackType = callback.type
    callbackArr.push({ onMsgCallback, callbackType })
  }
  if (socket.readyState === socket.OPEN) {
    // 已开启状态，状态值为1
    socket.send(data)
  } else if (socket.readyState === socket.CONNECTING) {
    // 若是 正在开启状态，则等待1s后重新调用
    setTimeout(function() {
      sendMsg(message, callback)
    }, 1000)
  } else {
    // 若未开启 ，则先开启，后重新调用
    if (!destory) {
      initWebSocket(globalMesgCallback)
      setTimeout(() => {
        sendMsg(message, callback)
      })
    }
  }
}

// 心跳检测，保持连接状态
const sendTestMes = () => {
  sendTimer = setInterval(res => {
    sendMsg({ makino: 'keep service' })
  }, 10000)
}

// 开始连接
const openSocket = (mesgCallback) =>{
  destory = false
  initWebSocket(mesgCallback)
}

// 关闭 WebSocket 连接
const closeSocket = () => {
  destory = true
  clearInterval(timer)
  clearInterval(sendTimer)
  timer = null
  sendTimer = null
  if (!socket) {
    return
  }
  socket.close()
  restart = false
}

// 握手连接请求
// message.header.type === "Handleshake.Response"
const handleshake = (callback) => {
  const socketReqData = {
    header: {
      sequence: 0,
      timestamp: new Date().getTime(),
      type: 'Handleshake.Request'
    },
    body: { name: 'makino', version: '1.0.0' }
  }
  sendMsg(socketReqData, { fn: callback, type: 'Handleshake.Response' })
}

// 开启诊断请求 @param: data={simpleToken,extranetCode}
// message.header.type === "Begin.Response"
const beginDiagnosis = (data, callback) => {
  const socketReqData = {
    header: {
      sequence: 1,
      timestamp: new Date().getTime(),
      type: 'Begin.Request'
    },
    body: {}
  }

  if (data.simpleToken) {
    socketReqData.body = {
      beginType: 1,
      token: data.simpleToken,
      code: data.extranetCode
    }
  } else {
    let user = getLocalStorage('USER_INFO')
    let company = getLocalStorage('TENANT')
    let pwd = getLocalStorage('PWD')
    let userId = '';
    let password = '';
    /*if(company.tenantCode=== 'makino' ){
      userId = user.user_id;
      password = 'user_id';
    }
    else {
      userId = user.account;
      password = pwd;
    }*/

    userId = user.user_id;
    password = 'user_id';

    console.log('远程连接用户登录参数:',{
      userId, password
    });

    socketReqData.body = {
      beginType: 2,
      user: userId,
      passwd: password,
      // user: user ? JSON.parse(user).user_id : '',
      // passwd: 'user_id',// user ? JSON.parse(user).access_token : '',
      company: company ? company.tenantCode : '',
      code: data.extranetCode
    }
  }
  sendMsg(socketReqData, { fn: callback, type: 'Begin.Response' })
}

// 关闭诊断请求
// message.header.type === "End.Response"
const endDiagnosis = (callback) => {
  const socketReqData = {
    header: {
      sequence: 2,
      timestamp: new Date().getTime(),
      type: 'End.Request'
    },
    body: null
  }
  sendMsg(socketReqData, { fn: callback, type: 'End.Response' })
}

// 获得当前PC系统内的串口号
const getComPorts = (callback) => {
  let socketReqData = {
    'header': {
      'sequence': 3,
      'timestamp': new Date().getTime(),
      'type': 'GetComPorts.Request'
    },
    'body': null
  }
  sendMsg(socketReqData, { fn: callback, type: 'GetComPorts.Response' })
}

export {
  initWebSocket,
  closeSocket,
  sendMsg,
  handleshake,
  beginDiagnosis,
  endDiagnosis,
  getComPorts,
  openSocket
}

